import { Navigate, Route, Routes } from "react-router-dom"
import React from "react"

const Login = React.lazy(() => import("../pages/Login"))

export const MainNoAuth = () => {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route
                path="*"
                element={
                    <Navigate
                        to={`/login?redirectUri=${encodeURIComponent(
                            `${window.location.pathname}${window.location.search}`
                        )}`}
                    />
                }
            />
        </Routes>
    )
}
